import {
    GET_USER,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    WHO_AM_I,
    WHO_AM_I_SUCCESS,
    LOGOUT,
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LOAD_TRANSLATIONS,
    LOAD_TRANSLATIONS_SUCCESS,
    LOAD_TRANSLATIONS_FAILURE,
    GET_ORDERS_SUCCESS,
    GET_ORDERS_REQUEST,
    ORDER_TOUR_GET_REQUEST,
    ORDER_TOUR_GET_SUCCESS,
    SET_SLUG_VISIBLE,
    SELECT_MEANING,
    TOGGLE_MENU,
    TOGGLE_CONTACTS,
    TOGGLE_VIDEO,
    TOGGLE_DISCOUNT,
    TOGGLE_LOGIN,
    TOGGLE_LANG_SELECT,
    TOGGLE_REVIEWS_POPUP,
    TOGGLE_FEEDBACK,
    TOGGLE_SUBSCRIBE,
    TOGGLE_COOKIES_POLICY,
    TOGGLE_REVIEW,
    TOGGLE_SHARE,
    TEXT_SEARCH_REQUEST,
    TEXT_SEARCH_SUCCESS,
    CHANGE_SEARCH_QUERY,
    SELECT_CURRENCY,
    GET_CURRENCY_FAILURE,
    GET_CURRENCY_SUCCESS,
    GET_CURRENCY_REQUEST,
    CLEAR_SEARCH_RESULTS,
    VALIDATE_MESSAGE,
    SEND_MESSAGE_REQUEST,
    SEND_MESSAGE_SUCCESS,
    SEND_MESSAGE_FAILURE,
    SEND_CUSTOM_TOUR_REQUEST,
    SEND_CUSTOM_TOUR_FAILURE,
    SEND_CUSTOM_TOUR_SUCCESS,
    SET_MESSAGE_RESULT,
    SET_CUSTOM_TOUR_RESULT,
    SET_LOGIN_RESULT,
    SUBSCRIBE_REQUEST,
    SUBSCRIBE_SUCCESS,
    SUBSCRIBE_FAILURE,
    SET_SUBSCRIBE_RESULT,
    SEND_REVIEW_REQUEST,
    SEND_REVIEW_SUCCESS,
    SEND_REVIEW_FAILURE,
    SET_REVIEW_RESULT,
    CHANGE_REVIEW_RATING,
    HOVER_RATING,
    SELECT_DISCOUNT,
    SHOW_ABOUT_VIDEO,
    GET_SEO_SUCCESS,
    LOAD_FACEBOOK_COUNT_SUCCESS,
    LOAD_FACEBOOK_COUNT_REQUEST,
    CLOSE_FACEBOOK,
    INIT_FACEBOOK,
    COUNTRY_GET_REQUEST,
    COUNTRY_GET_SUCCESS,
    CHANGE_CUSTOM_TOUR,
    CHANGE_PATH,
    CHECK_REDIRECT_REQUEST,
    CHECK_REDIRECT_SUCCESS,
    CHECK_REDIRECT_FAILURE,
    COMPLETE_REDIRECT

} from '../actions/user';


export default function user(state = {orders: [], meaningIndex: 0, search: {query: ""}, loader: {count: 0}}, action) {
    let orders;
    let loader;
    switch (action.type) {
        case GET_USER:
            return state;
        case LOGIN_REQUEST:
            loader = Object.assign({}, state.loader);
            if (loader.count) {
                loader.count++;
            } else {
                loader.count = 1;
            }
            return {...state, fetchLogin: true, loginPromise: null, loader: loader};
        case LOGIN_SUCCESS:
            if (state.loader) {
                loader = Object.assign({}, state.loader);
                loader.count--;
            } else {
                loader = {count: 1};
            }
           //console.info(action.req);
            return {...state, login_success: true, loginResult: null, fetchLogin: false, loginPromise: action.req.json(), loader: loader};
        case SET_LOGIN_RESULT:
            //console.info(action.req);
           //console.log(action.payload);
            let loginResult = action.payload.result;
            return {...state, loginResult: loginResult, email: (loginResult.user)?loginResult.user.email:null, loginPromise: null, loginError: (loginResult.status!='ok')?true:false, loginOpen: (loginResult.status!='ok')?true:false};
        case SEND_MESSAGE_REQUEST:
            return {...state, fetchMessage: true};
        case SEND_MESSAGE_SUCCESS:
            //console.info(action.req);
            return {...state, fetchMessage: false, message: {success: (action.req.status==201?true:false),promise: action.req}};
        case VALIDATE_MESSAGE:
            //console.info(action.req);
            return {...state, fetchMessage: false, message: {   result: action.payload, promise: null}};
        case SEND_MESSAGE_FAILURE:
            //console.info(action.req);
            return {...state, fetchMessage: false, message: {errors: [{message: 'Error'}]}};
        case SET_MESSAGE_RESULT:
            return {...state, fetchMessage: false, message: {success: state.message.success ,result: action.payload, promise: null}};

        case SUBSCRIBE_REQUEST:
            return {...state, fetchSubscribe: true};
        case SUBSCRIBE_SUCCESS:
           //console.info(action.req);
            return {...state, fetchSubscribe: false, subscribe: {success: (action.req.status==201?true:false),promise: action.req}};
        case SUBSCRIBE_FAILURE:
            //console.info(action.req);
            return {...state, fetchSubscribe: false, subscribe: {errors: [{message: 'Error'}]}};
        case SET_SUBSCRIBE_RESULT:
            return {...state, fetchSubscribe: false, subscribe: {success: state.subscribe.success ,result: action.payload, promise: null}};

        case LOAD_FACEBOOK_COUNT_SUCCESS:
            console.log(action.req);
            return {...state};
        case CLOSE_FACEBOOK:
            return {...state, facebook: {...state.facebook, close: true}};
        case INIT_FACEBOOK:
            return {...state, facebook: {...state.facebook, init: true}};
        case SEND_REVIEW_REQUEST:
            return {...state, fetchReview: true};
        case SEND_REVIEW_SUCCESS:
           //console.info(action.req);
            return {...state, fetchReview: false, review: {success: (action.req.status==201?true:false),promise: action.req}};
        case SEND_REVIEW_FAILURE:
            //console.info(action.req);
            return {...state, fetchReview: false, review: {errors: [{message: 'Error'}]}};
        case SET_REVIEW_RESULT:
            return {...state, fetchReview: false, review: {success: state.review.success ,result: action.payload, promise: null}};
        case CHANGE_REVIEW_RATING:
            return {...state, reviewRating: action.payload};
        case HOVER_RATING:
            return {...state, rating: {...state.rating, hoverRating: action.payload}};
        case LOGOUT_REQUEST:
            loader = Object.assign({}, state.loader);
            if (loader.count) {
                loader.count++;
            } else {
                loader.count = 1;
            }
            return {...state, loader: loader};
        case LOGOUT_SUCCESS:
            if (state.loader) {
                loader = Object.assign({}, state.loader);
                loader.count--;
            } else {
                loader = {count: 1};
            }
            return {...state, email: null, loader: loader};
        case WHO_AM_I_SUCCESS:
            let lang = state.lang;
            let newState = (action.req.data.result.user != 'guest' ? action.req.data.result.user : {email: null});
            if (!newState.lang) {
                newState.lang = lang;
            }
            if (action.req.data.result.user != 'guest') {
                newState.loginOpen = false;
            }
            newState.login_success = false;
            newState.loginResult = null;
            return Object.assign({}, state, newState);
        case LOAD_TRANSLATIONS_SUCCESS:
            return {...state, translations: action.req.data};
        case  LOAD_TRANSLATIONS_FAILURE:
            return {...state, translations: {}};
        case GET_ORDERS_REQUEST:
            return {...state, fetchOrders: true};
        case GET_ORDERS_SUCCESS:
            return {...state, orders: action.req.data, fetchOrders: false};
        case ORDER_TOUR_GET_REQUEST:
            orders = state.orders;
            orders[action.payload].tourFetching = true;
            return {...state, orders: orders};
        case ORDER_TOUR_GET_SUCCESS:
            orders = state.orders;
            orders[action.payload].tourFetching = false;
            orders[action.payload].program = action.req.data;
            return {...state, orders: orders};
        case SET_SLUG_VISIBLE:
            return {...state, slugVisible: action.payload};
        case SELECT_MEANING:
            return {...state, meaningIndex: action.payload};
        case TOGGLE_MENU:
           //console.log(!state.menuOpen);
            return {...state, menuOpen: (state.menuOpen?false:(action.payload?false:true)), contactsOpen: false};
        case TOGGLE_REVIEWS_POPUP:
            return {...state, reviewsPopupOpen: !state.reviewsPopupOpen};
        case TOGGLE_CONTACTS:
            return {...state, contactsOpen: !state.contactsOpen};
        case TOGGLE_LANG_SELECT:
            return {...state, langSelectOpen: !state.langSelectOpen};
        case TOGGLE_DISCOUNT:
            return {...state, discountOpen: !state.discountOpen};
        case TOGGLE_VIDEO:
            return {...state, videoOpen: !state.videoOpen};
        case TOGGLE_LOGIN:
            return {...state, loginOpen: !state.loginOpen};
        case TOGGLE_FEEDBACK:
            let feedbackOptions = null;
            if (action.payload.tour) {
                feedbackOptions = action.payload
            }

            return {...state, feedbackOpen: !state.feedbackOpen, feedbackOptions: feedbackOptions};
        case TOGGLE_SUBSCRIBE:
            return {...state, subscribeOpen: !state.subscribeOpen};
        case TOGGLE_COOKIES_POLICY:
            return {...state, cookiesPolicyOpen: !state.cookiesPolicyOpen};
        case TOGGLE_REVIEW:
            return {...state, reviewOpen: !state.reviewOpen};
        case TOGGLE_SHARE:
            return {...state, shareOpen: !state.shareOpen};
        case TEXT_SEARCH_REQUEST:
            loader = Object.assign({}, state.loader);
            if (loader.count) {
                loader.count++;
            } else {
                loader.count = 1;
            }
            return {...state, loader : loader};
        case TEXT_SEARCH_SUCCESS:
            if (state.loader) {
                loader = Object.assign({}, state.loader);
                loader.count--;
            } else {
                loader = {count: 1};
            }
            return {...state, search: {...state.search, results : action.req.data}, loader : loader};
        case CHANGE_SEARCH_QUERY:
            return {...state, search: {...state.search, query: action.payload}};
        case CLEAR_SEARCH_RESULTS:
            return {...state, search: {}};
        case SELECT_CURRENCY:
            return {...state, currency: action.payload};
        case SHOW_ABOUT_VIDEO:
            return {...state, showAboutVideo: true};
        case GET_SEO_SUCCESS:
            return {...state, seo: action.req.data};
        case GET_CURRENCY_SUCCESS:
            let activeCurrency = state.currency;
            action.req.data.forEach(function(currency){
                if (currency.id == activeCurrency.id) {
                    activeCurrency = currency;
                }
            });
            return {...state, currencyList: action.req.data, currency: activeCurrency};
        case COUNTRY_GET_SUCCESS:
            return {...state, countryList: action.req.data};
        case CHANGE_CUSTOM_TOUR:
            return {...state, customTourForm: action.payload};
        case SEND_CUSTOM_TOUR_REQUEST:
            return {...state, fetchMessage: true};
        case SEND_CUSTOM_TOUR_SUCCESS:
            //console.info(action.req);
            return {...state, fetchMessage: false, message: {success: (action.req.status==201?true:false),promise: action.req}};
        case SEND_CUSTOM_TOUR_FAILURE:
            //console.info(action.req);
            return {...state, fetchMessage: false, message: {errors: [{message: 'Error'}]}};

        case SET_CUSTOM_TOUR_RESULT:
            return {...state, fetchMessage: false, message: {success: state.message.success ,result: action.payload, promise: null}};

        case SELECT_DISCOUNT:
            return {...state, discount: action.payload};
        case CHANGE_PATH:
            return {...state, path: action.payload};
        case CHECK_REDIRECT_REQUEST:
            loader = Object.assign({}, state.loader);
            if (loader.count) {
                loader.count++;
            } else {
                loader.count = 1;
            }
            return {...state, lang: action.payload.lang, redirectPath: action.payload.path, loader: loader};
        case CHECK_REDIRECT_SUCCESS:
            if (state.loader) {
                loader = Object.assign({}, state.loader);
                loader.count--;
            } else {
                loader = {count: 1};
            }
            return {...state, fullRedirect: true, loader: loader};
            if (state.loader) {
                loader = Object.assign({}, state.loader);
                loader.count--;
            } else {
                loader = {count: 1};
            }
        case CHECK_REDIRECT_FAILURE:
            return {...state, mainRedirect: true, loader: loader};
        case COMPLETE_REDIRECT:
            return {...state, mainRedirect: false, fullRedirect: false};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/common/reducers/user.js